(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["r24-pdp-karussell"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var knopf = e.target instanceof Element ? e.target.closest('[data-r24-karussell-knopf]') : null;
    if (!knopf) return;
    var wurzel = knopf.closest('[data-r24-karussell]');
    var spur = wurzel ? wurzel.querySelector('[data-r24-karussell-spur]') : null;
    if (!spur) return;
    var karte = spur.querySelector('li');
    var schritt = karte ? karte.getBoundingClientRect().width + 20 : spur.clientWidth * 0.8;
    spur.scrollBy({ left: Number(knopf.getAttribute('data-r24-karussell-knopf')) * schritt, behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();
})();
